// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__7hM0I","title":"BackImages_title__1jaMZ","images":"BackImages_images__13cNe"};